module.exports = {"UM_DOMAIN":"plpum.heymath.com","REV_DOMAIN":"plprev.heymath.com","PC_DOMAIN":"plppc.heymath.com","WEB_DOMAIN":"plp.heymath.com","OPS_DOMAIN":"ops.heymath.com","LUMOS_PC_DOMAIN":"pc.heymath.com","LUMOS_UM_DOMAIN":"heymath.com","WIRIS_DOMAIN":"me.heymath.com","CS_DOMAIN":"cs.heymath.com","CP_DOMAIN":"contests.heymath.com","CONTEST_UM_DOMAIN":"contests.heymath.com/um","CP_DOMAIN_API":"contests.heymath.com/api"}


//////////////////
// WEBPACK FOOTER
// ./src/config/urls.json
// module id = 153
// module chunks = 0